import { createContext, PropsWithChildren, useContext } from "react";
import { FieldSetApi } from "../shared/types";

const FieldSetContext = createContext<FieldSetApi>(null!);

export function useFieldSetContext() {
    return useContext(FieldSetContext);
}

interface FieldSetProviderProps extends PropsWithChildren {
    fieldSet: FieldSetApi
}

export function FieldSetProvider({
    fieldSet,
    children
}: FieldSetProviderProps) {
    return <FieldSetContext.Provider value={fieldSet}>
        {children}
    </FieldSetContext.Provider>
}